import { o } from 'odata';
import { authHub, errorHub } from '@codehq/aurora-app-core/src';

const odata = {
  o(rootGetters) {
    const token = rootGetters['auth/getToken'];
    const organization = rootGetters['organizations/getOrganization'];
    return o(`${process.env.VUE_APP_APIURL}/odata/`, this.getConf(token, organization));
  },
  getConf: (token, organization) => ({
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      organizationid: `${organization?.id}`,
    }),
    onError: (x, e) => {
      if (e.status === 401) {
        authHub.$emit('user.unauthorized');
      } else {
        errorHub.$emit('network.error');
      }
    },
  }),
  parseId: (id) => {
    let i = id;
    if (Number.isNaN(id)) {
      i = `'${id}'`;
    }
    return i;
  },
};
export { odata };

export default {};
